import React from "react"
import styled from "styled-components"
import ApolloClient from "apollo-client"
import { NormalizedCacheObject } from "apollo-cache-inmemory"
import { useHistory } from "react-router"
import { debounce } from "lodash"

import { Text } from "./styled-compnent"
import colors from "src/theme/colors"
import "./style.scss"
import AutoCompleteSearch from "src/components/auto-complete-search/help-search"
import { searchHelpList } from "./services"

const HeaderSection = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: 50%;
  @media (max-width: 900px) {
    width: 80%;
  }
`

const SearchInput = styled.div<any>`
  display: flex;
  flex-direction: column;
  height:40px
  margin-top:1rem;
  position: relative;

`

type Props = {
  client: ApolloClient<NormalizedCacheObject>
}

const HelpHeader = (props: Props) => {
  const { client } = props
  const history = useHistory()
  const [searchList, setSearchList] = React.useState([])

  const debounceFn = React.useCallback(debounce(handleDebounceFn, 300), [])

  async function handleDebounceFn(inputValue) {
    const resp: any = await searchHelpList(client, inputValue)
    if (resp && resp.data) {
      const { searchHelpCenter } = resp.data
      setSearchList(searchHelpCenter || [])
    } else {
      setSearchList([])
    }
  }

  function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
    debounceFn(event.target.value)
  }

  const handleAutoChange = (value: string, title: string) => {
    const filterList: any = searchList.find((item: any) => item.title === title)

    history.push({
      pathname: `/help-center/collection/article/${filterList?.id}`,
      state: {
        title: filterList.title,
        description: filterList.description
      }
    })
  }

  return (
    <>
      <HeaderSection>
        <Text fontSize={25} fontWeight={300} color={colors.white}>
          Advice and answers from the Tolobi Team
        </Text>
        <SearchInput>
          <AutoCompleteSearch
            handleAutoChange={handleAutoChange}
            address={searchList}
            handleChange={handleChange}
            placeholder="Search for articles...."
          />
        </SearchInput>
      </HeaderSection>
    </>
  )
}

export default HelpHeader
